import s from './Security.module.css';

const Security = () => <div className={s.containerCabinet}>Security</div>

export default Security;
